module.exports = __webpack_public_path__ + "img/bg9.34ea2191.jpg";